module.exports = __webpack_public_path__ + "img/111034.a0dc4950.png";